import React, { Component } from 'react';
// import Left from '../../partials/Left';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
// import * as User from '../../helpers/User';
import ObserverView from './ObserverView';
import Mentorhistory from './Mentorhistory';
import ObserverForm from './ObserverForm';

const $= window.$;

class MyObserver extends Component {
	constructor(props) {
		super(props);
        this.state={
            actyetact: [],
            mentorhistory:[],
            formtodata : []

        };
        this.getObserverView = this.getObserverView.bind(this);
        // this.get = this.get.bind(this);

	}

	componentWillReceiveProps(nextProps) {
		$("#actob").click();
		this.getObserverView();
		//this.getTabs();
        Common.downTabClose();


	}

	getTabs(){
		let self=this;
						
		$('#parentHorizontalTab').easyResponsiveTabs({
			type: 'default', //Types: default, vertical, accordion
			width: 'auto', //auto or any width like 600px
			fit: true, // 100% fit in a container
			//closed: 'accordion', // Start closed if in accordion view
			tabidentify: 'hor_1', // The tab groups identifier
			activate: function (event) { // Callback function if tab is switched

				var $tab = $(this);
				var $info = $('#nested-tabInfo');
				var $name = $('span', $info);

				$name.text($tab.text());

				$info.show();
			}
		});
		$('#ChildVerticalTab_1').easyResponsiveTabs({
			type: 'vertical',
			width: 'auto',
			fit: true,
			tabidentify: 'ver_1',
		});
		//Common.showSmallLeftMenu();

		
		$('.resp-accordion').click(function(){

			if($(this).next().hasClass('activeobs')){
				self.getObserverView();
			}
			if($(this).next().hasClass('inactiveobs')){
				self.getObserverView();
			}
			if($(this).next().hasClass('viewobserver')){
				self.getObserverView();
			}
			if($(this).next().hasClass('mentorhis')){
				self.getObserverView();
			}
		});
	}

	 getObserverView(){
	 	//alert("in");

	 	Common.reactLoader("show", "Please wait...");
	 	let learnerID = Common.getUserData("id", true);
	 	let corporateID = Common.getUserData("corporateID", true);
		let productID = Common.getUserData("productID", true);
    	fetch(Config.domainUrl+'personal/observers-view', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,corporateID:corporateID,productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	Common.reactLoader("hide");
               	if(responseJson.status != 0){
	                this.setState({

	                	actyetact : responseJson.actyetact,
	                	mentorhistory : responseJson.mentorhistory,
	                	formtodata : responseJson.formtodata
	                });
               		
               	}

				Common.downTabClose();


   		 });



    }

 //   	get(){
	// 	//alert(JSON.stringify(this.state.actyetact));
	// 	this.setState({
 //        	actyetact : this.state.actyetact
 //        });

	// }

	componentWillMount() {
	   this.getObserverView();
	}

    componentDidMount() {

    	setTimeout(()=>{

			this.getTabs();					

		}, 2000);
    }




		render() {
			//alert(JSON.stringify(this.state.actyetact));//
			return (


				<section id="contentsection" className="contentarea" >
				    <div className="inner-title-bg journey-tit-bg">
				        <h1>
				            <span>
				                <img src={process.env.PUBLIC_URL+"/images/img-myobserver.jpg"} align="absmiddle" alt="" border="0"/>
				            </span>My Observers<br/>
				            <span className="subtitle">My learning support - my peers, friends, family members, seniors</span>
				        </h1>
				    </div>
				    <div className="myperformance myobservers">
				      <section id="semana-scroll-inner" className="scroll">
				          <section className="viewport">
				            <section className="overview">
				                  <div className="inner-content">
				                      <div id="parentHorizontalTab"  >
				                          <ul className="resp-tabs-list hor_1 horizontaltabbg">
				                              <a href="javascript:void(0)" onClick={this.getObserverView}><li >View my Observers <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" title="" border="0"/></div></li></a>
				                              <li >Add new Observer <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" title="" border="0"/></div></li>
				                              <a href="javascript:void(0)" onClick={this.getObserverView}><li >View Observer's footprint <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" title="" border="0"/></div></li></a>
				                          </ul>
				                          <div className="resp-tabs-container hor_1 tapmargntop" >
				                              <div className="tab-content viewobserver"   >
				                              	<ObserverView actyetact={this.state.actyetact} callFun={this.getObserverView}/>
				                              </div>
				                              <div className="tab-content">
				                              	<ObserverForm formtodata={this.state.formtodata} />
				                              </div>
				                              <div className="tab-content mentorhis">
				                              	<Mentorhistory  mentorhistory={this.state.mentorhistory}/>
				                              </div>
				                          </div>
				                      </div>
				                  </div>
				              </section>
				          </section>
				      </section>
				    </div>
				</section>

			);
		}
}

export default MyObserver;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/MyObserver.js